import React from 'react';
import style from './block.module.scss';
import { defineBlock, useEditor, ChildrenBlock, smartProps } from '@smartfire/gutenberg-react';
import { InnerBlocks } from '@wordpress/block-editor';
import classnames from 'classnames';

const FORM_TEMPLATE = [['smartfire/input'], ['smartfire/input']];

const FORM_TEMPLATE2 = [['smartfire/input'], ['smartfire/input']];

const ALLOWED_BLOCKS = ['smartfire/input', 'smartfire/textarea', 'smartfire/submit'];

function Block({ firstTemplate }) {
    const { isEditing } = useEditor();
    const blockClasses = classnames({
        [style.block]: true,
        [style.admin]: isEditing,
    });

    return (
        <div className={blockClasses}>
            {isEditing ? (
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={firstTemplate ? FORM_TEMPLATE : FORM_TEMPLATE2}
                    templateLock={false}
                />
            ) : (
                <ChildrenBlock />
            )}
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        firstTemplate: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Contact colonne',
        parent: ['smartfire/contact-form'],
    },
});
